import * as React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 160px;
    z-index: 99;

    @media only screen and (max-width: 580px) {
        top: 152px;
    }

    ${(props) =>
            props.theme.backgroundImage &&
            `background: url(${props.theme.backgroundImage}) no-repeat;`}
    ${(props) =>
            props.theme.backgroundImage &&
            `background-size: cover; background-position: bottom;`}
`;

const Center = styled.div`
    margin-top: 1rem;
    @media only screen and (min-width: 1200px) {
        width: 986px;
        margin-left: auto !important;
        margin-right: auto !important;
    }
`;

export default (props) => {
    return (
        <StyledDiv>
            <Center>{props.children}</Center>
        </StyledDiv>
    );
};
